export const colors = {
  gscale: {
    25: '#FEFEFE',
    50: '#F5F6F7',
    100: '#ECECED',
    200: '#DCDCDD',
    300: '#C5C5C6',
    400: '#AEAEAF',
    500: '#979798',
    600: '#808081',
    700: '#69696A',
    800: '#525253',
    900: '#3B3B3C',
    910: '#1B1B1C',
    950: '#0D0D0E',
  },
  gtred: {
    50: '#FBF3F1',
    100: '#F6CFC5',
    200: '#F0AB99',
    300: '#EB886C',
    400: '#E56440',
    500: '#E04014',
    600: '#BF3712',
    700: '#9E2E0F',
    800: '#7C250D',
    900: '#5B1C0A',
    950: '#3A1308',
  },
  fscarlet: {
    50: '#FCF2F0',
    100: '#F4CAC2',
    200: '#EBA194',
    300: '#E37965',
    400: '#DA5037',
    500: '#D22809',
    600: '#B42308',
    700: '#961E07',
    800: '#791807',
    900: '#5B1306',
    950: '#3D0E05',
  },
  corazon: {
    50: '#FBF1F2',
    100: '#F2C7CA',
    200: '#E99DA2',
    300: '#DF747B',
    400: '#D64A53',
    500: '#CD202B',
    600: '#AF1C25',
    700: '#91181F',
    800: '#73131A',
    900: '#550F14',
    950: '#370B0E',
  },
  dblue: {
    50: '#F0F5FC',
    100: '#C0D2EC',
    200: '#90AFDC',
    300: '#608BCC',
    400: '#3086BC',
    500: '#0045AC',
    600: '#013D96',
    700: '#014380',
    800: '#022C6B',
    900: '#022355',
    950: '#031B3F',
  },
  rblue: {
    50: '#F2F4FA',
    100: '#C7CEE3',
    200: '#9CA9CC',
    300: '#7183B4',
    400: '#465E9D',
    500: '#1B3886',
    600: '#183276',
    700: '#152B66',
    800: '#132555',
    900: '#101E45',
    950: '#0D1835',
  },
  ultramarine: {
    50: '#F2F4FA',
    100: '#CCD4F1',
    200: '#A6B4E8',
    300: '#7F95DE',
    400: '#5975D5',
    500: '#3355CC',
    600: '#2C49AD',
    700: '#253C8F',
    800: '#1D3070',
    900: '#162352',
    950: '#0F1733',
  },
  hiblue: {
    50: '#F4F8F9',
    100: '#DEF0FA',
    200: '#C4E0F3',
    300: '#A1C8EF',
    400: '#75A9E0',
    500: '#5890CC',
    600: '#4275AC',
    700: '#2B5A8C',
    800: '#1C426B',
    900: '#15314F',
  },
  mbase: {
    black: '#000000',
    white: '#FFFFFF',
    error: '#EF4444',
    warning: '#F59E0B',
    success: '#22C55E',
    personal: '#007A55',
    admin: '#155DFC',
    org: '#7008E7',
  },
} as const;
